import { render, staticRenderFns } from "./LandingPageEditorFeaturesEditor.vue?vue&type=template&id=56b938c8&scoped=true"
import script from "./LandingPageEditorFeaturesEditor.vue?vue&type=script&lang=js"
export * from "./LandingPageEditorFeaturesEditor.vue?vue&type=script&lang=js"
import style0 from "./LandingPageEditorFeaturesEditor.vue?vue&type=style&index=0&id=56b938c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b938c8",
  null
  
)

export default component.exports